import { RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import CastingPage from './pages/casting-page/casting-page.tsx';

const CastingComponent = lazy(() => import('./casting.tsx'));

export const castingRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <Suspense>
        <CastingComponent />
      </Suspense>
    ),
    children: [
      {
        index: true,
        element: <CastingPage />
      }
    ]
  }
];
